module.exports = new __parcel__URL__("step-notifications.0206673e.svg").toString();